import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { BaseScreenDirective } from "./base-screen.directive";

@Directive({
    selector: "[mSM]"
})
export class MSmScreenDirective extends BaseScreenDirective {
    protected readonly minWidth = 576;

    @Input() set mSM(tmpl: TemplateRef<any>) {
        this.elseTmpl = tmpl;
    }

    constructor(tmpl: TemplateRef<any>, containerRef: ViewContainerRef) {
        super(tmpl, containerRef);
    }
}
